import * as React from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function LinearProgressWithLabel({ title, value, label }: { title: string, value: number, label: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ minWidth: 55, mr: 1, ml: 1 }}>
        <Typography
          variant="body1"
          sx={{ color: 'text.secondary', textAlign: 'left', fontWeight: '600' }}
        >{title}</Typography>
      </Box>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={value}
          sx={{
            backgroundColor: 'rgb(240 222 200)', '& .MuiLinearProgress-bar': {
              backgroundColor: 'orange', // Color for the filled part
            }
          }} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', fontWeight: '600' }}
        >{label}</Typography>
      </Box>
    </Box>
  );
}